import { useQuery } from "@tanstack/react-query";

import type { Category } from "@/shared/domains";
import { queriesStore } from "../api";

export const useStateOptions = (categorySlug?: Category["slug"]) => {
  return useQuery({
    ...queriesStore.location.options._ctx.state(categorySlug),
    staleTime: Infinity,
  });
};
